var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReloEdgeCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4265_5034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.655 22C43.655 33.9644 33.9644 43.655 22 43.655C10.0356 43.655 0.345001 33.9644 0.345001 22C0.345001 10.0356 10.0356 0.344971 22 0.344971C33.9644 0.344971 43.655 10.0356 43.655 22Z",
    fill: "#FFDE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.884 13.8793C16.9382 13.365 17.3442 13.0131 17.7502 13.0131H19.9699C20.3488 13.0131 20.5654 13.2568 20.6736 13.5545L21.215 15.5847C21.215 15.5847 23.164 12.553 26.0603 12.553C27.6303 12.553 28.7943 13.0673 29.2003 13.4192C29.5251 13.6899 29.5793 14.0688 29.2815 14.4749L26.4664 18.3998C26.1957 18.8059 25.8167 18.86 25.546 18.7247C25.3565 18.6434 25.0858 18.5352 24.7069 18.5352C23.7324 18.5352 22.6767 19.4555 22.4331 21.0255L21.1067 30.5808C21.0255 31.1221 20.8361 31.447 20.0781 31.447H15.1516C14.7456 31.447 14.4208 31.0409 14.502 30.5808L16.8569 13.8793H16.884Z",
    fill: "black",
    fillOpacity: 0.88
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4265_5034"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.31,
    height: 43.31,
    fill: "white",
    transform: "translate(0.345001 0.344971)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloEdgeCircle);
export default __webpack_public_path__ + "static/media/relo_edge_circle.17d244731488560c9efb6670f40c8929.svg";
export { ForwardRef as ReactComponent };